import { isNil, isEqual } from 'lodash';
import ApiService from './ApiService';

//export const serviceUrl = "http://localhost:8081"; //USER_SERVICE_URL
export const serviceUrl = "https://heroku-adminservice.herokuapp.com";

export default class UploadService {
    static checkFileType(file) {
        const type = file.type;
        return type.match('image.*') || isEqual(type, '');
    }

    static getTimeStamp() {
        const today = new Date();
        const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
        return `${date} ${time}`;
    }

    static async uploadFile(file, filename) {
        if (!isNil(file) && !isNil(filename)) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('name', filename);

            const responseData = await ApiService.doPost(`${serviceUrl}/blogs/storeFile`, formData,
                { 'Content-Type': 'multipart/form-data' },
            );

            if (responseData) {
                return true;
            }
        }
        return false;
    }
}
